import { type OpenApiSchemaABCAnalysisCategory, type OpenApiSchemaABCCombinedCategory } from '../../api/schema';

export const ABC_ANALYSIS_CATEGORIES = ['A', 'B', 'C'] as const satisfies readonly OpenApiSchemaABCAnalysisCategory[];

export const ABC_COMBINED_CATEGORIES: OpenApiSchemaABCCombinedCategory[] = ABC_ANALYSIS_CATEGORIES.flatMap(
    (categoryAmount) =>
        ABC_ANALYSIS_CATEGORIES.map(
            (categoryUnits) => `${categoryAmount}${categoryUnits}` as OpenApiSchemaABCCombinedCategory
        )
);

export function isAbcAnalysisCategory(value: string): value is OpenApiSchemaABCAnalysisCategory {
    return (ABC_ANALYSIS_CATEGORIES as readonly string[]).includes(value);
}

export function isAbcCombinedCategory(value: unknown): value is OpenApiSchemaABCCombinedCategory {
    return typeof value === 'string' && (ABC_COMBINED_CATEGORIES as readonly string[]).includes(value);
}
